import React from 'react';
import SkillIcon from '../components/SkillIcon';
import SkillList from '../components/SkillList';
import CorpsSection from '../components/CorpsSection';

const Skills = (props) => {

    return (
        <CorpsSection id="skill" title={props.data.titleBloc}>


            {props.data.body.map((e, index) => (

                <div key={index} className="subheading mb-3">
                    {e.titleForTypeSkill}
                    {
                        e.listOrIcon === "icon" ? (
                            <SkillIcon icons={e.list} />

                        ) : (
                            <SkillList texts={e.list} />
                        )
                    }
                </div>
            ))
            }
        </CorpsSection >
    );
}

export default Skills;